import React from "react";

import { DATE_TIME_CONFIG } from "../../../config";
import DailyDispatch from "../../../pages/planning/DailyDispatch";
import { today } from "../../../utils/datetime";
import { PROJECT_DISPATCH_EMBED_CONFIG } from "../constants";
import { useProjectPageContext } from "./ProjectPageContext";

/**
 * Project Dispatch tab: embed compact Daily Dispatch for the current project.
 *
 * @returns {JSX.Element}
 */
const ProjectDispatch = () => {
  const { project } = useProjectPageContext();

  return (
    <div className="overflow-hidden rounded-xl border border-gray-100 bg-gray-100 shadow-sm shadow-gray-300">
      <DailyDispatch
        title={`Project ${project.number} Dispatch`}
        compact={PROJECT_DISPATCH_EMBED_CONFIG.compact}
        readOnly={PROJECT_DISPATCH_EMBED_CONFIG.readOnly}
        singleProject={
          PROJECT_DISPATCH_EMBED_CONFIG.singleProject ? project : null
        }
        detailsOnly={PROJECT_DISPATCH_EMBED_CONFIG.detailsOnly}
        loadDayDetails={PROJECT_DISPATCH_EMBED_CONFIG.loadDayDetails}
        loadWeather={PROJECT_DISPATCH_EMBED_CONFIG.loadWeather}
        initialDate={today()}
        disableUrlSync
        startOfWeek={DATE_TIME_CONFIG.START_OF_WEEK.dispatch}
        embedded
      />
    </div>
  );
};

export default ProjectDispatch;
